// extracted by mini-css-extract-plugin
export default {"page":"styles_page__P9P0n","title":"styles_title__r6vWT","subtitle":"styles_subtitle__5lko5","text":"styles_text__CLPAL","listItem":"styles_listItem__7pjs7"};